export const ScreeningPaymentType = {
    ApplePay: "Apple Pay",
    Cash: "Cash",
    CreditCard: "Credit Card",
    GooglePay: "Google Pay",
    CardOnFile: "Card on file",
} as const;
